export const version = 'kunde-v1.20.0-SNAPSHOT-bcba0d1609f64b1c173d87eb979c58f937b2eb9d';